// ignore-string-externalization

import {
  cssColorValue,
  screenSmMax,
  screenXsMax,
  cssSpacing,
} from '@spotify-internal/encore-web';
import styled, { css } from 'styled-components';
import { ImageAspectBox16x9 } from '../../ui';
import { transformScaleUp } from '../../utils';

type ImageWrapperType = { video: boolean; featured: boolean };

export const ImageWrapper = styled(ImageAspectBox16x9)<ImageWrapperType>`
  overflow: hidden;

  /* for videos add a black gradient overlay at the bottom to make the play button
     slightly more visible */
  ${props =>
    props.video &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        box-shadow: inset 0 -90px 10px 0 rgba(0, 0, 0, 0.1);
        z-index: 2;
      }
    `}

  /* play icon */
  svg {
    display: ${props => (props.video ? 'initial' : 'none')};
    position: absolute;
    bottom: ${props =>
      props.featured ? cssSpacing('looser') : cssSpacing('base')};
    left: ${props =>
      props.featured ? cssSpacing('looser') : cssSpacing('base')};
    width: ${props => (props.featured ? '48px' : '32px')};
    height: auto;
    color: ${cssColorValue('backgroundBase')};
    z-index: 3;

    @media (max-width: ${screenXsMax}) {
      bottom: ${cssSpacing('tighter')};
      left: ${cssSpacing('tighter')};
    }

    @media (max-width: ${screenSmMax}) {
      bottom: ${cssSpacing('base')};
      left: ${cssSpacing('base')};
    }
  }

  &:hover {
    img,
    svg {
      ${transformScaleUp};
      transition: transform 0.3s ease-in-out;
    }
    svg {
      opacity: 0.8;
    }
  }
`;
